import React from "react";
import classes from "./styles.module.scss";
import { useLocation, Link, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const BreadcrumbComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathnames = location.pathname.split("/").filter(x => x);

  const homePageHandler = () => {
    navigate("/", { replace: true });
  };

  return (
    <div className={classes.breadcrumb_container}>
      <ul className={classes.breadcrumb_list}>
        <li className={classes.breadcrumb_item}>
          <button onClick={homePageHandler} className={classes.home_btn}>
            <HomeIcon className={classes.icon} />
            <span>Home</span>
          </button>
        </li>
        {/* display next icons  */}
        {pathnames.length > 0 && (
          <li className={classes.separator}>
            <NavigateNextIcon className={classes.separator_icon} />
          </li>
        )}

        {/* map all path separated by "/", using sting split methods */}
        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const formattedValue = value.replace(/-/g, " ");

          let displayName;
          if (location.pathname === "/faq") {
            displayName = formattedValue.toUpperCase();
          } else {
            displayName =
              formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);
          }

          return (
            <React.Fragment key={to}>
              <li
                className={`${classes.breadcrumb_item} ${isLast ? classes.active : ""}`}
              >
                {isLast ? (
                  <span className={classes.current_page}>{displayName}</span>
                ) : (
                  <Link to={to} className={classes.breadcrumb_link}>
                    {displayName}
                  </Link>
                )}
              </li>
              {/* edge case if the last element is not last then display next icon */}
              {!isLast && (
                <li className={classes.separator}>
                  <NavigateNextIcon className={classes.separator_icon} />
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default BreadcrumbComponent;
